/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import { SDK_FRAGMENT_NAME } from '@msdyn365-commerce/core-internal';
import * as React from 'react';
import { ICustomCodeProps } from './custom-code.props.autogenerated';

/**
 *
 * CustomCode component
 */
class CustomCode extends React.PureComponent<ICustomCodeProps<{}>> {
    constructor(props: ICustomCodeProps<{}>) {
        super(props);
    }
    public render(): JSX.Element | null {
        const { config } = this.props;
        const code = config.code;
        const staticUrl = `${this.props?.context?.request?.url?.staticCdnUrl}${process.env.SUBMISSIONID}/`;
        const codeC = code
            ?.split('href="/')
            .join(`href="${staticUrl}`)
            .split('src="/')
            .join(`src="${staticUrl}`);
        // tslint:disable:react-no-dangerous-html -- intentionally set inner html
        return React.createElement(SDK_FRAGMENT_NAME, {
            key: this.props.id,
            dangerouslySetInnerHTML: { __html: codeC }
        });
    }
}
export default CustomCode;
